import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OrderByPipe } from 'components';
import { take } from 'rxjs/operators';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ReminderWrapperService } from 'src/app/core/services/service-wrappers/reminder-wrapper.service';
import { updateReminders } from 'src/app/core/state/reminders/reminders.actions';

@Component({
  standalone: false,
  selector: 'app-reminders-list',
  templateUrl: './reminders-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reminders-list.component.scss']
})
export class RemindersListComponent implements OnInit {
  privReminders;
  orderPipe: OrderByPipe = new OrderByPipe();

  @Input()
  get reminders(): any {
    return this.privReminders;
  }
  set reminders(e) {
    this.privReminders = e;
    this.applyFilter();
  }

  @Input()
  isLoading: boolean;

  @Input()
  isLoaded: boolean;

  @Input()
  error: any;

  displayReminders: any;
  filterValue = '';

  constructor(
    private store: Store<any>,
    private reminderService: ReminderWrapperService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {}
  setFilter(e) {
    this.filterValue = e.value;
    this.applyFilter();
  }

  applyFilter() {
    this.displayReminders = this.orderPipe.transform(this.reminders, 'scheduledDate');
  }

  getOverflowMenuOptions(reminder) {
    if (reminder.patientId) {
      return [
        { id: 'delete', label: 'Dismiss' },
        { id: 'patient', label: 'View Patient' }
      ];
    }
    return [{ id: 'delete', label: 'Dismiss' }];
  }

  overflowMenuClicked(id, reminder) {
    if (id === 'delete') {
      this.reminderService
        .apiV1ReminderIdDelete(reminder.id)
        .pipe(take(1))
        .subscribe(
          (x) => {
            this.store.dispatch(updateReminders());
          },
          (err) => this.notificationService.error('Error dismissing reminder')
        );
    } else if (id === 'patient') {
      this.viewPatient(reminder.patientId);
    } else {
      this.store.dispatch(updateReminders());
    }
  }

  viewPatient(patientId) {
    this.router.navigate(['/', 'accounts', 'detail', patientId]);
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}
